// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productAvailabilityStyles } from "@guestsupply/Overrides/Components/ProductAvailability";
import QuestionTooltip from "@guestsupply/XDL/Icons/QuestionTooltip";
import { createLinkIconStyles, ellipsis } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productAvailabilityStyles.container = {
    gap: 0,
    css: css`
        flex-grow: 0;
    `,
};
productAvailabilityStyles.messageGridItem = { width: 12 };
productAvailabilityStyles.availabilityByWarehouseLinkGridItem = { width: 12 };
productAvailabilityStyles.availabilityByWarehouseModal = {
    size: 400,
    cssOverrides: {
        modalContent: css`
            padding: 0;
        `,
        modalTitle: css`
            padding: 10px 10px 10px 20px;
        `,
        headlineTypography: css`
            font-size: 20px;
            margin-bottom: 0;
        `,
    },
};
productAvailabilityStyles.centeringWrapper = {
    css: css`
        height: 100px;
        width: 100%;
        display: flex;
        align-items: center;
    `,
};
productAvailabilityStyles.spinner = {
    css: css`
        margin: 0 auto;
    `,
};
productAvailabilityStyles.messageText = {
    ...createLinkIconStyles(QuestionTooltip, {
        typographyProps: {
            size: 12,
            weight: "bold",
            css: css`
                margin-left: 2px;
                line-height: 13px;
                max-width: 145px;
                text-wrap: wrap;
                ${ellipsis(2)}
            `,
        },
        icon: {
            iconProps: {
                size: 12,
                color: "text.link",
            },
            position: "right",
        },
        css: css`
            &&& {
                display: flex;
                @media print {
                    display: inline-flex !important; // to override !important css to hide buttons on print
                    ${IconWrapper} {
                        display: none;
                    }
                }
            }
        `,
    }),
};
productAvailabilityStyles.noAdditionalAvailabilityInfoLink = {
    typographyProps: {
        size: 12,
    },
    css: css`
        @media print {
            &&& {
                display: inline-flex !important; // to override !important css to hide buttons on print
                ${IconWrapper} {
                    display: none;
                }
            }
        }
    `,
};
productAvailabilityStyles.realTimeText = {
    weight: "bold",
    css: css`
        display: inline-block;
        text-align: left;
        min-width: 25px;

        &::after {
            overflow: hidden;
            display: inline-block;
            vertical-align: bottom;
            animation: ellipsis steps(4, end) 900ms infinite 1s;
            content: "\\2026";
            width: 0;
        }

        @keyframes ellipsis {
            to {
                width: 1.25em;
            }
        }
    `,
};
productAvailabilityStyles.errorText = {
    weight: "bold",
};
productAvailabilityStyles.tooltip = {
    cssOverrides: {
        tooltipClickable: css`
            display: flex;
            margin: 0;
        `,
    },
};

productAvailabilityStyles.QuestionIconStyles = {
    color: "primary",
    size: 12,
    css: css`
        opacity: 0.33;
        cursor: pointer;
        &:hover {
            color: ${getColor("common.ui8")};
        }
    `,
};

productAvailabilityStyles.callAvailabilityIcon = {
    size: 12,
    css: css`
        margin-right: 6px;
    `,
};
